
export default {
    props: {
        educator: String,
        socialIcons: Array,
        ePage: String
    }
}
